import React from 'react';
import { useNavigate } from 'react-router-dom';
import './ticketList.css'

const TicketList = ({ tickets, children }) => {
  const ticketCount = children ? children : 5;
  const navigate = useNavigate();

  const handleRowClick = (ticket_id) => {
    navigate(`/ticket/${ticket_id}`);
  };

  const getStatusClassName = (status) => {
    const statusMap = {
      'Opened': 'status-opened',
      'Resolved': 'status-resolved',
      'Closed': 'status-closed',
      'Pending': 'status-pending'
    };
    return statusMap[status] || '';
  };

  // Get the last ticketCount tickets and reverse them
  const displayedTickets = tickets.slice(-ticketCount).reverse();

  return (
    <div className="ticket--list">
      <div className="ticket-table-container">
        <table className="ticket-table">
          <thead>
            <tr>
              <th>Ticket ID</th>
              <th>Title</th>
              <th>Client</th>
              <th>Category</th>
              <th>Status</th>
              <th>Priority</th>
              <th>Created At</th>
              <th>Closed At</th>
            </tr>
          </thead>
          <tbody>
            {displayedTickets.map((ticket) => (
              <tr
                key={ticket.ticket_id}
                onClick={() => handleRowClick(ticket.ticket_id)}
                style={{ cursor: "pointer" }}
              >
                <td>{ticket.ticket_id}</td>
                <td>{ticket.ticket_title}</td>
                <td>{ticket.ticket_client}</td>
                <td>{ticket.ticket_category}</td>
                <td className={getStatusClassName(ticket.ticket_status)}>
                  {ticket.ticket_status}
                </td>
                <td>{ticket.ticket_priority}</td>
                <td>{ticket.createdAt}</td>
                <td>{ticket.closedAt || 'N/A'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TicketList;